import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

const postscribe = typeof window !== "undefined" ? require("postscribe") : null

class EmbedCode extends Component {
  state = {
    loaded: false,
  }

  componentDidMount() {
    const { blok } = this.props

    if (postscribe) {
      postscribe(this.instance, blok.embed_code, {
        done: this.onLoad,
      })
    }
  }

  onLoad = () => {
    this.setState({
      loaded: true,
    })
  }

  getFSWrapperClass() {
    const { blok } = this.props
    const { loaded } = this.state

    return !blok._editable && !loaded ? "fs-wrapper--loading" : ""
  }

  render() {
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className={["fs-wrapper", this.getFSWrapperClass()].join(" ")}>
          <div ref={(el) => (this.instance = el)} />
        </div>
      </SbEditable>
    )
  }
}

EmbedCode.propTypes = {
  blok: PropTypes.shape({
    embed_code: PropTypes.string,
  }).isRequired,
}

export default EmbedCode
